// RELATAR UM PROBLEMA, direto da tela inicial.
//
// O relato ja existia, escondido na aba "Carreiras" do modal da conta -- tres
// toques de distancia de quem acabou de ver o jogo quebrar. Aqui ele fica a um
// toque, ao lado de "Como jogar" e do premium.
//
// ⚠️ SO PARA QUEM TEM CONTA, por decisao do dono. O servidor continua
// aceitando relato anonimo (a rota nunca exigiu token), e isso e de proposito:
// quem esta travado a ponto de nao conseguir entrar ainda precisa conseguir
// avisar. O que muda e o BOTAO -- ele so aparece para quem esta logado, porque
// relato sem e-mail nao tem como ser respondido, e responder e metade do
// valor de receber.
//
// Junto com o texto vao um PRINT (opcional) e um pacote de DIAGNOSTICO. Os
// dois existem pelo mesmo motivo: reduzir a ida e volta de "em que tela?",
// "que versao?", "da para mandar uma foto?". Ver `diagnostico.js`.

import React, { useState } from 'react';
import { Modal } from './ui.jsx';
import { reportBug, readAccount } from './api.js';
import { marcar } from './analytics.js';
import { diagnostico, prepararImagem } from './diagnostico.js';

/** O minimo que o servidor aceita -- ele recusa abaixo de 10 caracteres. */
const MINIMO = 10;

export function BugModal({ onClose, tela = 'home', state = null }) {
  const [texto, setTexto] = useState('');
  const [imagem, setImagem] = useState(null);      // { dataUri, largura, altura }
  const [busy, setBusy] = useState(false);
  const [erro, setErro] = useState('');
  const [enviado, setEnviado] = useState(false);

  const escolherImagem = async (e) => {
    const arquivo = e.target.files?.[0];
    e.target.value = '';                            // permite reescolher o mesmo arquivo
    if (!arquivo) return;
    setErro('');
    try {
      setImagem(await prepararImagem(arquivo));
    } catch (err) {
      /* Falhar aqui NAO pode travar o relato: a imagem e um extra, o texto e
         o essencial. A pessoa e avisada e segue. */
      setImagem(null);
      setErro(`${err.message} Voce pode enviar o relato sem ela.`);
    }
  };

  const enviar = async () => {
    setBusy(true); setErro('');
    try {
      await reportBug(readAccount()?.token, {
        texto,
        tela,
        versao: typeof __BUILD__ === 'string' ? __BUILD__ : undefined,
        imagem: imagem?.dataUri,
        diag: diagnostico({ tela, state }),
      });
      marcar('bug_relatado', { tela, comImagem: !!imagem });
      setEnviado(true);
    } catch (err) {
      setErro(String(err?.message || err));
    } finally {
      setBusy(false);
    }
  };

  if (enviado) {
    return (
      <Modal title="Obrigado" onClose={onClose}>
        <p className="muted" style={{ marginTop: 0 }}>
          Relato enviado. Ele chega direto para quem cuida do jogo, com o seu
          e-mail junto — se precisarmos de detalhe, a gente responde.
        </p>
        <button className="primary" style={{ width: '100%' }} onClick={onClose}>Fechar</button>
      </Modal>
    );
  }

  const kb = imagem ? Math.round((imagem.dataUri.length * 0.75) / 1024) : 0;

  return (
    <Modal title="Relatar um problema" onClose={onClose}>
      <p className="muted small" style={{ marginTop: 0 }}>
        Conte o que voce estava fazendo e o que aconteceu. Quanto mais especifico,
        mais rapido isso vira conserto.
      </p>
      <textarea
        rows={4}
        value={texto}
        maxLength={800}
        onChange={(e) => setTexto(e.target.value)}
        placeholder="ex: fui vender o Gui no mercado e a tela ficou branca"
      />
      <div className="row spread small dim" style={{ marginTop: 6 }}>
        <span>{texto.trim().length < MINIMO ? `pelo menos ${MINIMO} caracteres` : ' '}</span>
        <span>{texto.length}/800</span>
      </div>

      {/* O print e opcional, e e a coisa que mais economiza pergunta de volta:
          um botao cortado se explica numa imagem e nao se explica em texto. */}
      <div className="bug-anexo">
        {!imagem && (
          <label className="bug-anexo-botao">
            <span>📎 Anexar um print</span>
            <input type="file" accept="image/*" onChange={escolherImagem} hidden />
          </label>
        )}
        {imagem && (
          <div className="bug-anexo-previa">
            <img src={imagem.dataUri} alt="print anexado" />
            <div className="bug-anexo-info">
              <div className="small">{imagem.largura}×{imagem.altura} · {kb} KB</div>
              <button className="ghost sm" onClick={() => setImagem(null)}>tirar</button>
            </div>
          </div>
        )}
      </div>

      <p className="small dim" style={{ margin: '10px 0 0', lineHeight: 1.4 }}>
        Vai junto a versao do jogo, a tela em que voce esta e a situacao da sua
        carreira — nada do conteudo dela, e nenhum dado seu alem do e-mail da
        conta.
      </p>

      {erro && <div className="small neg" style={{ marginTop: 8 }}>{erro}</div>}
      <button
        className="primary"
        style={{ width: '100%', marginTop: 10 }}
        disabled={busy || texto.trim().length < MINIMO}
        onClick={enviar}
      >
        {busy ? 'Enviando...' : 'Enviar relato'}
      </button>
    </Modal>
  );
}
